import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import CallListForm from './call_list_form';

export default class CallListCreationModal extends React.Component {
  static propTypes = {
    shown: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  render() {
    const { shown, onClose } = this.props;
    return (
      <Modal
        bsSize={"small"}
        className="call-list-creation-modal"
        show={shown}
      >
        <Modal.Header>
          <Modal.Title>Create New Call List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CallListForm onClose={onClose} />
        </Modal.Body>
      </Modal>
    );
  }
}
